module.exports = __webpack_public_path__ + "img/login_tab01_05.c69bf252.png";